import { cn } from '@/lib/utils'

interface ScreenataPageHeaderProps {
  className?: string
  titleClassName?: string
  descriptionName?: string
  title: string
  description?: React.ReactNode
  icon?: React.ReactNode
  titleExtra?: React.ReactNode
}

export default function ScreenataPageHeader(props: ScreenataPageHeaderProps) {
  const {
    className,
    titleClassName,
    descriptionName,
    title,
    description,
    icon,
    titleExtra,
  } = props
  return (
    <div className={cn('', className)}>
      <div className='flex items-center gap-2'>
        {icon}
        <h1
          className={cn(
            'font-heading text-2xl font-semibold text-foreground',
            titleClassName
          )}
        >
          {title}
        </h1>
        {titleExtra}
      </div>

      {description && (
        <span className={cn('text-sm text-muted-foreground', descriptionName)}>
          {description}
        </span>
      )}
    </div>
  )
}
